// Formatação da EAP de um documento.
//
// As duas funções recebem o projeto/apropriações por parâmetro em vez de lerem
// o contexto. Elas são chamadas de dentro de `.map()` na renderização, e
// `useProjectContext` é um `useContext` — um hook. Chamado ali, o número de
// hooks do componente muda conforme a lista cresce (expandir um pedido com 12
// itens acrescentava 60 chamadas), e o React derruba a árvore com "Rendered
// more hooks than during the previous render".
//
// Documento de obra MEGA não traz apropriação por EAP: as rotas do ERP não
// devolvem vínculo com serviço da planilha e o pipeline tem proibição explícita
// de inferi-lo. Por isso a ausência é tratada como estado válido nas duas, em
// vez de estourar.

export const formatWbsPath = (item, activeProject) => {
  const level = `wbs_code_id_${activeProject?.appropriation_level}`;
  const code = item?.[level];
  if (typeof code !== "string" || !code) return "";
  const root = activeProject?.wbs_code_id;
  return root ? code.replace(root, "") : code;
};

export const findWbsPath = (appropriations, level, wbs) => {
  const path = level === "units" ? "building_unit_name" : "description";
  return appropriations?.[level]?.find((i) => i.wbs_code_id === wbs)?.[path] ?? "-";
};
